import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// export default from './Tabs';
// 20181211animated，scrollAnimated（ScrollableTabBarMixin），inkBarAnimated（InkTabBarMixin）都是默认为true的
// 去掉所有的动画
import createClass from 'create-react-class';
import React from "react";
import { Tabs as TabsInner } from './Tabs';
import SearchTabs from './SearchTabs';
import Tab from './Tab';
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _super.apply(this, arguments);
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          extraContent = _this$props.extraContent,
          tabBarExtraContent = _this$props.tabBarExtraContent,
          tabPosition = _this$props.tabPosition,
          tabBarPosition = _this$props.tabBarPosition,
          tabBarStyle = _this$props.tabBarStyle,
          style = _this$props.style;
      var tabBarStyleTypeMap = {
        line: 'simple',
        card: 'upborder',
        'editable-card': 'editable-card',
        'simple': 'simple',
        'fill': 'fill',
        'primary': 'primary',
        'trangle': 'trangle',
        'upborder': 'upborder',
        'fade': 'fade',
        'downborder': 'downborder',
        'trapezoid': 'trapezoid'
      };
      isShouldUpdate("Tabs", this.props);
      var disableProps = {
        animated: false,
        scrollAnimated: false,
        // scrollableBar的class
        inkBarAnimated: false,
        // inkBar的class
        useTransform3d: false,
        //是否使用translate3d來实现线条
        tabBarPosition: tabPosition ? tabPosition : tabBarPosition,
        extraContent: tabBarExtraContent ? tabBarExtraContent : extraContent,
        style: _typeof(tabBarStyle) === 'object' && tabBarStyle ? tabBarStyle : style,
        tabBarStyle: tabBarStyleTypeMap[this.props.type ? this.props.type : this.props.tabBarStyle]
      };
      return /*#__PURE__*/React.createElement(TabsInner, _extends({}, this.props, disableProps));
    }
  }]);

  return Tabs;
}(React.Component);

;
Tabs.TabPane = TabsInner.TabPane;
Tabs.SearchTabs = SearchTabs;
Tabs.SearchTabs.Item = Tab;
export default Tabs;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/index.js